export const oauthValidateAuthorizationRequest = "/oauth/validate_authorization_request";
